import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["value"]

import { watch, ref } from "vue";
import setup from "../setupComposable/setup";
import commonProps from "../props/commonProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputDate',
  props: commonProps,
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { onInput } = setup(emit);
const hidePlacheHolder = ref(false);
watch(props, (props) => {
  if (props.modelValue !== null) {
    if (("" + props.modelValue).length > 0) {
      hidePlacheHolder.value = false;
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$attrs.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass({ required: _ctx.$attrs.required })
        }, _toDisplayString(_ctx.$attrs.label), 3))
      : _createCommentVNode("", true),
    _createElementVNode("input", _mergeProps({
      class: ["form-control", { 'remove-default-placeholder': hidePlacheHolder.value }],
      value: _ctx.modelValue
    }, _ctx.$attrs, {
      type: "date",
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onInput) && _unref(onInput)(...args)))
    }), null, 16, _hoisted_1)
  ]))
}
}

})